<template>
<div id="error_code">
    <div style="width: 421px; height: 254px; background: #F7F7F7 0% 0% no-repeat padding-box; border-radius: 6px; margin-top: 16px;">     
        <!-- <span>REQUEST</span> -->        
        <div style="display: flex; justify-content: space-between; align-items: center; background: #F7F7F7 0% 0% no-repeat padding-box; border: 1px solid #DEDEDE; border-radius: 6px;width: 421px; height: 42px; margin: 16px 0 0 0;"
            :style="{'background': currentError.code ? '#2A343A' : ''}">
        <!-- <div style="text-align: right; padding: 16px 16px 0px 16px; border-bottom: 1px solid #DEDEDE; height: 35px !important;"> -->
            <!-- <Dropdown v-model="selectedCity" :options="cities" optionLabel="name" placeholder="# Nombre librería" style="background: #F7F7F7; border: 0px; color: #C4C4C4 !important; top: -15px; height: 30px;" class="p-dropdown-label-1"/> -->
            <div style="
                height: auto;
                height: 100%;
                border-radius: 6px 0px 0px 6px;
                display: flex;
                align-items: center;
                text-align: center;
                padding: 0px 16px 0px 16px;
                "
                :style="{'color': currentError.code ? '#C4C4C4' : ''}"
            >
                Response
            </div>
            <div style="z-index: 323232; position: absolute;">
                <div id="myDropdowncode" class="dropdown-content-filter-code">
                    <div class="dropdown-container-code">
                        <div style="
                            font-size: 12px
                            font-family: var(--font-acumin-pro-light);
                            font-weight: 300;
                            letter-spacing: -0.17px;
                            color: #606B86;
                            padding: 12px 12px 12px 12px;
                        ">
                            Application/json; charset=UFT-8
                        </div>
                        <div style="justify-content: start; display: flex; padding: 0px 12px 0px 12px; cursor: pointer;" v-for="success in successes" @click="selectError(success)" :class="[success.activated ? '' : 'disabled']">
                            <div style="width: 12px; height: 12px; background: #0DA771 0% 0% no-repeat padding-box; margin-right: 8px; border-radius: 50px;" :style="{'background': success.type === 'errors' ? '#D12940' : success.type === 'successes' ? '#0DA771' : ''}"></div>
                            <div style="font-size: 14px !important; font-weight: 600; letter-spacing: -0.2px; color: #808184;">{{ success.code }}</div>
                        </div>
                        <div style="border: 1px solid #DEDEDE; width: 100%; margin: 16px 0px 16px 0px;"></div>
                        <div style="
                            font-size: 12px
                            font-family: var(--font-acumin-pro-light);
                            font-weight: 300;
                            letter-spacing: -0.17px;
                            color: #606B86;
                            padding: 0px 12px 12px 12px;
                        ">
                            Application/json; charset=UFT-8
                        </div>
                        <div style="justify-content: start; display: flex; padding: 0px 12px 14px 12px; cursor: pointer;" v-for="err in errors" @click="selectError(err)" :class="[err.activated ? '' : 'disabled']">
                            <div style="width: 12px; height: 12px; background: #D12940 0% 0% no-repeat padding-box; margin-right: 8px; border-radius: 50px;" :style="{'background': err.type === 'errors' ? '#D12940' : err.type === 'successes' ? '#0DA771' : ''}"></div>
                            <div style="font-size: 14px !important; font-weight: 600; letter-spacing: -0.2px; color: #808184;">{{ err.code }}</div>
                        </div>
                        <div 
                            @click="cleanResponse()"
                            style="
                                justify-content: start;
                                display: flex;
                                padding: 12px 12px 12px 12px;
                                font-size: 14px;
                                letter-spacing: -0.2px;
                                color: #D12940;
                                border-top: 1px solid #DEDEDE;
                                font-family: var(--font-acumin-pro-regular);
                                cursor: pointer;
                            "
                        >
                            Limpiar ejemplo
                        </div>
                    </div>
                </div>
            </div>
            <div style="
                padding: 0px 8px 0px 8px; display:flex; justify-content:center; align-items: center;">
                <div style="justify-content: center; display: flex;" v-if="currentError.code">
                    <div style="width: 12px; height: 12px; background: #D12940 0% 0% no-repeat padding-box; margin-right: 8px; border-radius: 50px;" 
                                :style="{'background': currentError.type === 'errors' ? '#D12940' : currentError.type === 'successes' ? '#0DA771' : ''}"></div>
                    <div style="font-size: 14px; font-weight: 600; 
                                font-family: var(--font-acumin-pro-semibold);
                                letter-spacing: -0.2px;
                                color: #808184;">{{ currentError.code }}</div>
                </div>
                <button @click="myFunction()" class="dropbtncode" style="width: 100%; background: #F7F7F7 0% 0% no-repeat padding-box;" :style="{'background': currentError.code ? '#2A343A' : ''}">
                    <span style="display: inline;">
                        <span style="
                            font-size: 12px !important;
                            font-weight: 600;
                            font-family: var(--font-acumin-pro-semibold);
                            letter-spacing: -0.17px;
                            color: #808184 !important;
                            display: inline;
                            float: left;
                        "
                    
                        >   Ejemplos
                            <span style="margin-left: 8px;">
                                <i class="pi icon-technical-dropdown" style="background: #808184; width: 12px; height: 6px;"></i>
                            </span>
                        </span>
                    </span>
                </button>
            </div>
        </div>
        <div style="text-align: center; padding-top: 16px !important;" v-if="!currentError.code">
            <p style="font-size: 14px !important; font-weight: 500; letter-spacing: -0.2px; color: #606B86; padding: 9px 0 9px 0;">Choose an example:<p>
            <p style="font-size: 14px !important; letter-spacing: -0.2px; color: #606B86; padding: 0px 0 16px 0;">Application/json; charset=UFT-8</p>
            
            <div style="width: 100%; justify-content: center; display: flex">
                <div style="width: 320px; justify-content: center; display: flex; display: flex; flex-flow: wrap; gap: 8px;">
                    <div style="cursor: pointer;" v-for="success in successes" @click="selectErrorTwo(success)" :class="[success.activated ? '' : 'disabled']">
                        <div style="display: flex; gap: 8px;">
                            <div style="width: 12px; height: 12px; background: #0DA771 0% 0% no-repeat padding-box; border-radius: 50px;"></div>
                            <div style="font-size: 14px !important; font-weight: 600; letter-spacing: -0.2px; color: #808184;">{{ success.code }}</div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div style="width: 373px; height: 0px; border: 1px solid #DEDEDE; margin: 16px 24px 16px 24px;">
            </div>
            <div style="text-align: center; padding-bottom: 16px;">
                <span style="font-size: 14px; letter-spacing: -0.2px; color: #606B86;">Application/problem+json; charset=UFT-8</span>
            </div>

            <div style="width: 100%; justify-content: center; display: flex">
                <div style="width: 320px; justify-content: center; display: flex; display: flex; flex-flow: wrap; gap: 8px;">
                    <div style="cursor: pointer;" v-for="error in errors" @click="selectErrorTwo(error)" :class="[error.activated ? '' : 'disabled']">
                        <div style="display: flex; gap: 8px;">
                            <div style="width: 12px; height: 12px; background: #D12940 0% 0% no-repeat padding-box; border-radius: 50px;"></div>
                            <div style="font-size: 14px !important; font-weight: 600; letter-spacing: -0.2px; color: #808184;">{{ error.code }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div style="widht: 100%; justify-content: center; display: flex; flex-direction: column">
                <div style="justify-content: center; display: flex;">
                    <div style="justify-content: center; display: flex; cursor: pointer;" v-for="error in errors" @click="selectErrorTwo(error)" :class="[error.activated ? '' : 'disabled']">
                        <div style="width: 12px; height: 12px; background: #D12940 0% 0% no-repeat padding-box; margin-right: 8px; border-radius: 50px;"></div>
                        <div style="font-size: 14px !important; font-weight: 600; letter-spacing: -0.2px; color: #808184;">{{ error.code }}</div>
                    </div>
                </div>
            </div> -->
        </div>
        <div>
            <slot></slot>
        </div>
        <div style="border: 1px solid #6D7278; height: 37px !important; text-align: left;background: #2A343A;" v-if="currentError.code">
            <i id="button1" class="pi icon-technical-copy" style="width: 18px; height: 20px; background: #C4C4C4; cursor: pointer; margin: 7px 16px 7px 16px;" @click="CopyToClipboard('div1')" />
        </div>
    </div>
</div>
</template>
<script>
import Dropdown from 'primevue/dropdown';
export default {
    components: { Dropdown },
    name: 'ErrorCode',
    props: {
        data: {
            type: Array,
            default: () => [
                { 'code': '200', 'codeId': '200', 'title': 'OK', 'description': 'Detalle de la transacción pendiente de aprobación', 'type': 'successes', 'activated': true},
                { 'code': '200', 'codeId': '200', 'title': 'OK', 'description': 'Detalle de la transacción pendiente de aprobación', 'type': 'successes', 'activated': true},
                { 'code': '200', 'codeId': '200', 'title': 'OK', 'description': 'Detalle de la transacción pendiente de aprobación', 'type': 'successes', 'activated': true},
                { 'code': '200', 'codeId': '200', 'title': 'OK', 'description': 'Detalle de la transacción pendiente de aprobación', 'type': 'successes', 'activated': true},
                { 'code': '200', 'codeId': '200', 'title': 'OK', 'description': 'Detalle de la transacción pendiente de aprobación', 'type': 'successes', 'activated': true},
                { 'code': '200', 'codeId': '200', 'title': 'OK', 'description': 'Detalle de la transacción pendiente de aprobación', 'type': 'successes', 'activated': true},
                { 'code': '200', 'codeId': '200', 'title': 'OK', 'description': 'Detalle de la transacción pendiente de aprobación', 'type': 'successes', 'activated': true},
                { 'code': '200', 'codeId': '200', 'title': 'OK', 'description': 'Detalle de la transacción pendiente de aprobación', 'type': 'successes', 'activated': true},              
                { 'code': '500', 'codeId': '500', 'title': 'Internal Server Error', 'description': 'Respuesta de detalle cuando el usuario no tiene los privilegios para acceder a la transacción', 'type': 'errors', 'activated': true},
                { 'code': '500', 'codeId': '500-1', 'title': 'Internal Server Error', 'description': 'Respuesta de detalle cuando el usuario no tiene los privilegios para acceder a la transacción', 'type': 'errors', 'activated': true}]
        },
    },
    data: () => {
        return {
            selectedCity: null,
            cities: [],
            currentError: {}
        }
    },
    computed: {
        successes: function() {
            return this.data.filter((x) => { return x.type === 'successes'})
        },
        errors: function() {
            return this.data.filter((x) => { return x.type === 'errors'})
        }
    },
    methods: {
        myFunction() {
            window.document.getElementById("myDropdowncode").classList.toggle("showcode")
        },
        selectError(err) {
            this.showResponse(err)
            this.myFunction()
        },
        selectErrorTwo(err) {
            this.showResponse(err)
        },
        showResponse(err) {
            if (err.codeId !== this.currentError.codeId) {
                if (this.currentError.codeId) {
                    window.document.getElementById(this.currentError.codeId).classList.remove("show-codes")
                }
                window.document.getElementById(err.codeId).classList.toggle("show-codes")
            }
            this.currentError = err
        },
        cleanResponse() {
            window.document.getElementById('myDropdowncode').classList.remove("showcode")
            this.currentError = {}
            this.data.map((x) => {
                window.document.getElementById(x.codeId).classList.remove("show-codes")
            })
            // this.myFunction()
        },
        CopyToClipboard(containerid) {
            var range = document.createRange();
            range.selectNode(document.getElementById(this.currentError.codeId));
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges();// to deselect
        }
    }
}
</script>
<style lang="stylus">
.dropbtncode
  width: 100%;
  height: auto !important;
  background-color: #F7F7F7;
  color: white;
  padding: 12px 12px 12px 16px;
  // border: 1px solid #F3F7F8;
  cursor: pointer;
  border-top: 0px solid #e2e2e2;
  border-bottom: none;
  border-right: none;
  border-left: none;

.dropbtncode:hover, .dropbtncode:focus {
  background-color: #F7F7F7;
}

.dropbtncode:focus-visible {
  outline: none
}

.dropdowncode {
  position: relative;
  display: inline-block;
  width 100%
}

.dropdown-content-filter-code {
  display: none;
  position: relative;
  background-color: #f9f9f9;
  min-width: 264px;
  
  z-index: 1;
}

.dropdown-content-filter-code a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  width 100%
}

.dropdown-code a:hover {background: #EEEEEE 0% 0% no-repeat padding-box;}

.showcode {
    display: block;
    bottom: 125px;
    display: flex;
    position: relative;
    right: -156px;
    background: #F7F7F7 0% 0% no-repeat padding-box;
    border: 1px solid #DEDEDE;
    border-radius: 6px;
    width: 264px;
    height: auto;
}

.dropdown-container-code {
  width: 100%;
}

.hidden-codes {
    display: none;
    position: absolute;
    background: #F4F4F4 0% 0% no-repeat padding-box;
    z-index: 1;
}

.show-codes {
    display: block;
    position: relative;
}

.disabled
{
    pointer-events: none;
    opacity: 0.7; 
}

#error_code {
    pre, pre[class*="language-"] {
        height: 182px !important;
        border-radius: 0px !important;
    }
}

</style>
